import { useTranslation } from 'react-i18next';

/**
 * SkipToContent — Spec 10-5 Part 1
 * Hidden link that becomes visible on focus, allowing keyboard users
 * to skip past navigation directly to the main content area.
 */
export function SkipToContent() {
  const { t } = useTranslation('shell');
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[10000] focus:bg-primary focus:text-primary-foreground focus:px-4 focus:py-2 focus:rounded-md focus:text-body focus:font-medium focus:shadow-lg"
    >
      {t('a11y.skipToContent')}
    </a>
  );
}
